export function BlacklistManagementPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Blacklist Management</h1>
      <p className="text-muted-foreground">Manage blacklisted addresses.</p>
    </div>
  );
}
